export enum DirectionType {
    ARRIVAL = "ARRIVAL",
    DEPARTURE = "DEPARTURE"
}